<div class="main-content">
  <div class="main-container">
    <ov-suite-hierarchy-table
      [title]="'Return Order ID: ' + return.id"
      [formClass]="formClass"
      [hasBulkUpload]="false"
      [excludeColumns]="4"
      [showTopBar]="true"
      [dropdownData]="dropdownData"
      [hideAddButton]="true"
      [filter]="filter"
    >
    </ov-suite-hierarchy-table>
  </div>
</div>
